import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    FormControl,
    TextField,
    Paper,
    Button,
    IconButton,
    Tooltip,
    Stack,
    useTheme,
    LinearProgress,
    Select,
    MenuItem,
    InputLabel,
    Alert,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import * as Yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import {
    // DataGrid,
    GridToolbarContainer,
    // GridToolbarColumnsButton,
    // GridToolbarFilterButton,
    // GridToolbarExport,
    // GridToolbarDensitySelector,
    GridToolbarQuickFilter,
} from "@mui/x-data-grid";

import { Formik } from "formik";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { DataGrid } from "@mui/x-data-grid";
import { useProSidebar } from "react-pro-sidebar";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import ResetTvIcon from "@mui/icons-material/ResetTv";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { tokens } from "../../Theme";
import store from "../../index";
import { LoadingButton } from "@mui/lab";
import { useDispatch } from "react-redux";
import { fetchExplorelitview } from "../../store/reducers/Explorelitviewapireducer";
import FileListPopup from "../../ui-components/FIleViewDialog";
import FileUploadIconButton from "../../ui-components/FileUploadButton";
import { attachmentPost } from "../../store/reducers/LoginReducer";
import GradingIcon from '@mui/icons-material/Grading';
import {
    fetchApidata,
    explorePostData,
    postData,
    getFetchData,
    requestMail,
    PermissionApprovalVerify,
} from "../../store/reducers/Formapireducer";
import { toast } from "react-hot-toast";
import { formGap } from "../../ui-components/global/utils";
import { leaveAppoval, mailNotify } from "../../store/reducers/Listviewapireducer";
import { Productautocomplete } from "../../ui-components/global/Autocomplete";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import axios from "axios";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever'
import CryptoJS from "crypto-js";

const KEY = CryptoJS.enc.Utf8.parse("1234567890123456"); // 16-byte key
const IV = CryptoJS.enc.Utf8.parse("1234567890123456"); // 16-byte IV
function decryptDataUrlSafe(urlSafeBase64) {
    // Convert back to standard base64
    let base64 = urlSafeBase64.replace(/-/g, "+").replace(/_/g, "/");
    // Add padding if needed
    while (base64.length % 4 !== 0) {
        base64 += "=";
    }

    const decrypted = CryptoJS.AES.decrypt(
        { ciphertext: CryptoJS.enc.Base64.parse(base64) },
        KEY,
        {
            iv: IV,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        }
    );

    return decrypted.toString(CryptoJS.enc.Utf8);
}
const Otapproval = ({ appId, empId }) => {
    const isNonMobile = useMediaQuery("(min-width:600px)");
    const navigate = useNavigate();
    const params = useParams();
    const location = useLocation();
    const mode = params.Mode;
    var recID = decryptDataUrlSafe(params.id);
    const dispatch = useDispatch();
    var compID = sessionStorage.getItem("companyId");
    const [open, setOpen] = useState(false);
    //   var recID = params.id;
    var accessID = "TR216";
    // const { toggleSidebar, broken, rtl } = useProSidebar();
    const listViewData = useSelector((state) => state.listviewApi.rowData);
    const listViewColumn = useSelector((state) => state.listviewApi.columnData);
    const listViewurl = useSelector((state) => state.globalurl.listViewurl);
    const [showtable, setShowtable] = useState(false);
    const getLoading = useSelector((state) => state.formApi.getLoading);
    const data = useSelector((state) => state.formApi.Data);
    const isLoading = useSelector((state) => state.formApi.loading);
    const [pageSize, setPageSize] = useState(10);
    const [rowCount, setRowCount] = useState(0);
    const [show, setScreen] = React.useState("0");
    const [files, setFiles] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const rowSx = { height: 36, '& td, & th': { py: 0.5 } };
    const EMPID = sessionStorage.getItem("EmpId");
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [showImage, setShowImage] = useState(params.Mode == "IM" ? true : false)

    const validationSchema = Yup.object().shape({
        ProName: Yup.object()
            .nullable()
            .required("Project is required"),
    });
    useEffect(() => {
        dispatch(getFetchData({ accessID, get: "get", recID })).then((res) => {
            console.log(res, "response");
            console.log(res.payload.Data.EmployeeID, "response");
            var url = store.getState().globalurl.empGetAttachmentUrl;
            axios.get(url, {
                params: {
                    empId: data.EmployeeID,
                    appId: recID
                }
            })
                .then((response) => {
                    setFiles(response.data);
                })
                .catch((err) => {
                    setError('Failed to fetch attachments.');
                    console.error(err);
                })
                .finally(() => setLoading(false));

        })
    }, []);


    const [proName, setProName] = useState(null);

    const currentDate = new Date().toISOString().split('T')[0];
    console.log(data.ProjectID, "--data.ProjectID");

    const otInitialValue = {
        Date: data.OtDate,
        applieddate: mode == "A" ? currentDate : data.AppliedDate,
        NumberOfHours: data.NumberOfHours,
        comments: data.Comments,
        Status: data.Status,
        //  paymentmethods: data.PaymentMethod == "" ? "AS" : data.PaymentMethod,
        paymentmethods: data.PaymentMethod,
        ReimbursementOption: data.ReimbursementOption,
        managerComments: data.ManagerComments,
        OtType: data.OtType,
        ProName: data.ProjectID
            ? { RecordID: data.ProjectID, Name: data.ProjectName }
            : null,
    };
    const otFNsave = async (values, resetForm, del) => {
        setLoading(true);
        // console.log(funMode, "+  funMode");
        console.log(data, "--data.ProjectID");
        let action =
            mode === "A" && !del
                ? "insert"
                : mode === "E" && del
                    ? "harddelete"
                    : "update";
        // const idata = {
        //     RecordID: data.RecordID,
        //     ProjectID: values?.ProName?.RecordID || 0,
        //     ProjectName: values?.ProName?.Name || "",
        //     OtDate: values.Date,
        //     AppliedDate: values.applieddate,
        //     NumberOfHours: values.NumberOfHours,
        //     Status: mode == "A" ? "AL" : mode == "E" && values.Status == "QR" ? "AL" : values.Status, Status: mode == "A" ? "AL" : mode == "E" && values.Status == "QR" ? "AL" : values.Status,
        //     Comments: values.comments,
        //     PaymentMethod: values.paymentmethods,
        //     ReimbursementOption: values.ReimbursementOption,
        //     OtType: values.OtType,
        //     EmployeeID: mode == "M" ? params.parentID : EMPID,
        //     ManagerComments: values.managerComments,
        //     Source: "Self",
        // };
        const response = await dispatch(
            PermissionApprovalVerify({
                // action: "update",
                // DailyTaskRecordID: recID,
                // ApprovedBy: params.managerID,
                // Status: values.status,
                // PASSWORD: values.password,
                // ManagerComments: values.ManagerComments ? values.ManagerComments : "",
                RecordID: recID,
                EmployeeID: data.EmployeeID,
                ManagerID: params.managerID,
                Status: values.Status,
                Type: "OT",
                Password: values.password,
                ManagerComments: values.managerComments ? values.managerComments : ""
            })
        );
        if (response.payload.Status === "Y") {
            dispatch(mailNotify({
                EmployeeID: data.EmployeeID,
                ManagerID: params.managerID,
                Reason: "",
                RecordID: recID,
                Source: "M",
                Status: values.Status == "AP" ? "Y" : values.Status == "RJ" ? "N" : "Q",
                Type: "OT"
            })
            );
            toast.success(response.payload.Msg);
            navigate(`/approval/notification/OT/${values.Status}`);
        } else {
            console.log("🚀 ~ DTSaveFn ~ response.payload.Msg:", response.payload.Msg)
            toast.error(response.payload.Msg);
        }
    };

    function LeaveTool() {
        return (
            <GridToolbarContainer
                sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                }}
            >
                <Box sx={{ display: "flex", flexDirection: "row" }}>
                    {/* <Typography>{(show == "2" ? "List of Leave" :show == "6" ? "List of OT" : (show == "1" ? "List of Allowance" :"List of Deductions"))}</Typography> */}

                    <Typography variant="h5">List of OT{`(${rowCount}))`}</Typography>
                </Box>

                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                    }}
                >
                    <GridToolbarQuickFilter />
                    <Tooltip title="ADD">
                        <IconButton type="reset">
                            <AddOutlinedIcon />
                        </IconButton>
                    </Tooltip>
                </Box>
            </GridToolbarContainer>
        );
    }
    const explorelistViewData = useSelector(
        (state) => state.exploreApi.explorerowData
    );
    const explorelistViewColumn = useSelector(
        (state) => state.exploreApi.explorecolumnData
    );
    const exploreLoading = useSelector((state) => state.exploreApi.loading);
    const screenChange = (event) => {
        setScreen(event.target.value);
    };
    const VISIBLE_FIELDS = [
        "SLNO",
        "OtDate",
        "NumberOfHours",
        "Status",
        "action",
    ];
    const [funMode, setFunMode] = useState("A");
    const columns = React.useMemo(
        () =>
            explorelistViewColumn
                ? explorelistViewColumn.filter((column) =>
                    VISIBLE_FIELDS.includes(column.field)
                )
                : [],
        [explorelistViewColumn]
    );

    const fnLogOut = (props) => {
        Swal.fire({
            title: `Do you want ${props}?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: props,
        }).then((result) => {
            if (result.isConfirmed) {
                if (props === "Logout") navigate("/");
                if (props === "Close") navigate(-1);
            }
        });
    };
    async function fileUpload(file, EMPID, action, id, purpose) {
        console.log("🚀 ~ fileUpload ~ file:", file)
        const formData = new FormData();
        formData.append('file', file);
        formData.append('empId', data.EmployeeID);
        formData.append('appId', data.RecordID);
        formData.append('type', "OT");
        formData.append('source', "Self");
        formData.append("action", action);
        formData.append("id", id);
        formData.append("purpose", purpose);
        console.log("🚀 ~ fileUpload ~ formData:", formData)
        const respose = await dispatch(attachmentPost({ data: formData }))

        if (respose.payload.success) {
            toast.success(respose.payload.message)
            //setShowtable(true);
            var url = store.getState().globalurl.empGetAttachmentUrl;
            axios
                .get(url, {
                    params: {
                        empId: data.EmployeeID,
                        appId: data.RecordID,

                    }
                })
                .then((response) => {
                    setFiles(response.data);
                })
                .catch((err) => {
                    setError('Failed to fetch attachments.');
                    console.error(err);
                })
                .finally(() => setLoading(false));
        }
        else {
            toast.success(respose.payload.message)
        }

        console.log("🚀 ~ fileUpload ~ respose:", respose)
    }
    return (
        <React.Fragment>
            {getLoading && <LinearProgress />}
            <Paper elevation={3} sx={{ margin: "0px 10px", background: "#F2F0F0" }}>
                <Box display="flex" justifyContent="space-between" p={2}>
                    <Box display="flex" borderRadius="3px" alignItems="center">
                        {/* {broken && !rtl && (
                            <IconButton onClick={() => toggleSidebar()}>
                                <MenuOutlinedIcon />
                            </IconButton>
                        )} */}
                        <Typography variant="h5">Over Time</Typography>
                    </Box>
                    <Box display="flex">
                        <Tooltip title="Close">
                            <IconButton onClick={() => fnLogOut("Close")} color="error">
                                <ResetTvIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Logout">
                            <IconButton color="error" onClick={() => fnLogOut("Logout")}>
                                <LogoutOutlinedIcon />
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Box>
            </Paper>

            {!getLoading ? (
                <Paper elevation={3} sx={{ margin: "10px" }}>
                    {/* <Box m="20px"> */}
                    {mode === "IM" && (
                        <Box
                            display="flex"
                            padding={1}
                            justifyContent="flex-end"
                            mt="2px"
                            gridColumn="span 4"
                            gap={2}
                            marginBottom={-5}
                        >
                            <IconButton
                                onClick={() => setShowImage(prev => !prev)}
                            >
                                <ArrowDownwardIcon sx={{ color: "blue" }} />
                            </IconButton>
                        </Box>)}
                    <Formik
                        initialValues={otInitialValue}
                        enableReinitialize={true}
                        validationSchema={validationSchema}
                        onSubmit={(values, { resetForm }) => {
                            setTimeout(() => {
                                otFNsave(values, resetForm, false);
                            }, 100);
                        }}
                    >
                        {({
                            errors,
                            touched,
                            handleBlur,
                            handleChange,
                            isSubmitting,
                            values,
                            handleSubmit,
                            resetForm,
                            setFieldValue
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <Box
                                    display="grid"
                                    gap={formGap}
                                    padding={1}
                                    gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                                    sx={{
                                        "& > div": {
                                            gridColumn: isNonMobile ? undefined : "span 4",
                                        },
                                    }}
                                >

                                    <FormControl sx={{ gridColumn: "span 2", gap: "15px" }}>
                                        <TextField
                                            name="applieddate"
                                            type="date"
                                            id="applieddate"
                                            label="Applied Date"
                                            variant="standard"
                                            focused
                                            inputFormat="YYYY-MM-DD"
                                            value={values.applieddate}
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            error={!!touched.applieddate && !!errors.applieddate}
                                            helperText={touched.applieddate && errors.applieddate}
                                            sx={{ gridColumn: "span 2" }}
                                            inputProps={{
                                                max: new Date().toISOString().split("T")[0],
                                                readOnly: true,
                                            }}
                                            InputLabelProps={{ shrink: true }}
                                        // disabled={mode == "E" && values.Status != "AL" && values.Status != "RC"}
                                        />

                                        <Productautocomplete
                                            name="ProName"
                                            label={
                                                <>
                                                    Project
                                                    <span style={{ color: "red" }}> * </span>
                                                </>
                                            }
                                            disabled
                                            id="ProName"
                                            value={values.ProName}
                                            onChange={(newValue) => {
                                                setFieldValue("ProName", newValue);
                                                // setProName(newValue.RecordID);
                                            }}
                                            url={`${listViewurl}?data={"Query":{"AccessID":"2054","ScreenName":"Project","Filter":"parentID=${compID}","Any":""}}`}
                                        />
                                        {touched.ProName && errors.ProName && (
                                            <div style={{ color: "red", fontSize: "12px", marginTop: "-8px" }}>
                                                {errors.ProName}
                                            </div>
                                        )}
                                        {!showImage ? <React.Fragment>

                                            <TextField
                                                // disabled={mode == "E" && values.Status != "AL" && values.Status != "RC"}
                                                name="Date"
                                                type="date"
                                                id="Date"
                                                label="OT Date"
                                                inputFormat="YYYY-MM-DD"
                                                variant="standard"
                                                focused
                                                value={values.Date}
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                required
                                                sx={{ gridColumn: "span 2" }}
                                                InputLabelProps={{ shrink: true }}
                                                inputProps={{ readOnly: true }}
                                            />

                                            <TextField
                                                // disabled={mode == "E" && values.Status != "AL" && values.Status != "RC"}
                                                name="NumberOfHours"
                                                type="number"
                                                id="NumberOfHours"
                                                label="No. of Hours"
                                                variant="standard"
                                                focused
                                                value={values.NumberOfHours}
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                onWheel={(e) => e.target.blur()}
                                                required
                                                sx={{ gridColumn: "span 2", background: "" }}
                                                InputProps={{
                                                    inputProps: {
                                                        readOnly: true,
                                                        style: { textAlign: "right" },
                                                        min: 0,
                                                        max: 10,
                                                    },
                                                }}
                                            />
                                            {/* <FormControl
                        disabled={mode == "E" && values.Status != "AL" && values.Status != "RC"}
                      /> */}


                                            <FormControl
                                                // disabled={mode == "E" && values.Status != "AL"}
                                                focused
                                                variant="standard"
                                                sx={{ gridColumn: "span 2" }}
                                            >
                                                <InputLabel id="paymentmethods">
                                                    Payment Methods
                                                </InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-filled-label"
                                                    id="paymentmethods"
                                                    name="paymentmethods"
                                                    value={values.paymentmethods}
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    error={
                                                        !!touched.paymentmethods && !!errors.paymentmethods
                                                    }
                                                    helperText={
                                                        touched.paymentmethods && errors.paymentmethods
                                                    }
                                                    inputProps={{ readOnly: true }}
                                                    sx={{
                                                        gridColumn: "span 2",
                                                        backgroundColor: "#ffffff",
                                                        "& .MuiFilledInput-root": {
                                                            backgroundColor: "#ffffff",
                                                        },
                                                    }}
                                                >
                                                    <MenuItem value="CR">Cash Reimbursement</MenuItem>
                                                    <MenuItem value="CH">Compensatory Half</MenuItem>
                                                    {/* <MenuItem value="AS">As it is</MenuItem>
                        <MenuItem value="TH">Time and a Half</MenuItem>
                        <MenuItem value="DT">Double Time</MenuItem>
                        <MenuItem value="CS">Compensate</MenuItem> */}
                                                </Select>
                                            </FormControl>
                                            {(mode == "M") ? (


                                                <FormControl
                                                    //   disabled={mode == "E" && values.Status != "AL" && values.Status != "RC"}
                                                    focused
                                                    variant="standard"
                                                    sx={{ gridColumn: "span 2" }}
                                                >
                                                    <InputLabel id="ReimbursementOption">
                                                        Reimbursement Option
                                                    </InputLabel>
                                                    <Select
                                                        labelId="demo-simple-select-filled-label"
                                                        id="ReimbursementOption"
                                                        name="ReimbursementOption"
                                                        value={values.ReimbursementOption}
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                        error={
                                                            !!touched.ReimbursementOption &&
                                                            !!errors.ReimbursementOption
                                                        }
                                                        helperText={
                                                            touched.ReimbursementOption &&
                                                            errors.ReimbursementOption
                                                        }
                                                        inputProps={{ readOnly: true }}
                                                        sx={{
                                                            gridColumn: "span 2",
                                                            backgroundColor: "#ffffff",
                                                            "& .MuiFilledInput-root": {
                                                                backgroundColor: "#ffffff",
                                                            },
                                                        }}
                                                    >
                                                        <MenuItem value="OH">One Time and Half</MenuItem>
                                                        <MenuItem value="HT">One and Half Time</MenuItem>
                                                        <MenuItem value="CH">Compensatory Half</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            ) : false}
                                            <FormControl
                                                // disabled={mode == "E" && values.Status != "AL" && values.Status != "RC"}
                                                focused
                                                variant="standard"
                                                sx={{ gridColumn: "span 2" }}
                                            >
                                                <InputLabel id="OtType">OT Type</InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-filled-label"
                                                    id="OtType"
                                                    name="OtType"
                                                    value={values.OtType}
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    error={!!touched.OtType && !!errors.OtType}
                                                    helperText={touched.OtType && errors.OtType}
                                                    inputProps={{ readOnly: true }}
                                                    sx={{
                                                        gridColumn: "span 2",
                                                        backgroundColor: "#ffffff",
                                                        "& .MuiFilledInput-root": {
                                                            backgroundColor: "#ffffff",
                                                        },
                                                    }}
                                                >
                                                    <MenuItem value="FS">Flexible Scheduling</MenuItem>
                                                    <MenuItem value="SS">Shift Swaps</MenuItem>
                                                </Select>
                                            </FormControl>

                                            <TextField
                                                // disabled={mode == "E" && values.Status != "AL" && values.Status != "RC"}

                                                // disabled={mode == "E" && values.Status != "AL"}
                                                fullWidth
                                                variant="outlined"
                                                type="text"
                                                label="Comments"
                                                required
                                                multiline
                                                rows={6}
                                                value={values.comments}
                                                id="comments"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                name="comments"
                                                error={!!touched.comments && !!errors.comments}
                                                helperText={touched.comments && errors.comments}
                                                sx={{
                                                    gridColumn: "span 2",
                                                    backgroundColor: "",
                                                    "& .MuiFilledInput-root": {
                                                        backgroundColor: "",
                                                    },
                                                }}
                                                focused
                                                inputProps={{ readOnly: true }}
                                            />
                                            {/* {mode == "M" || (mode == "E" && (values.Status == "RJ" || values.Status == "RC")) ? ( */}
                                            <TextField
                                                //   disabled={mode == "E" && values.Status != "AL"}

                                                fullWidth
                                                variant="outlined"
                                                type="text"
                                                label="Manager Comments"
                                                required
                                                multiline
                                                rows={6}
                                                value={values.managerComments}
                                                id="managerComments"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                name="managerComments"
                                                sx={{
                                                    gridColumn: "span 2",
                                                }}
                                                focused
                                            />
                                            {/* ) : false} */}
                                            {/* {mode == "M" && ( */}
                                            <TextField
                                                select
                                                label="Status"
                                                id="Status"
                                                name="Status"
                                                value={values.Status}
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                required
                                                focused
                                                variant="standard"
                                            >
                                                {/* {mode != "M" && <MenuItem value="AL">Applied</MenuItem>} */}
                                                <MenuItem value="AP">
                                                    Approved
                                                </MenuItem>
                                                <MenuItem value="RJ">
                                                    Rejected
                                                </MenuItem>
                                                <MenuItem value="QR">
                                                    Query
                                                </MenuItem>
                                            </TextField>
                                            {/* )} */}

                                            {/* {mode == "E" && values.Status == "AP" && (
                                                <Alert variant="filled" sx={{ mt: 1 }} severity="success">
                                                    Your Over Time Request Approved.
                                                </Alert>
                                            )}
                                            {mode == "E" && values.Status == "RJ" && (
                                                <Alert variant="filled" sx={{ mt: 1 }} severity="error">
                                                    Your Over Time Request Rejected.
                                                </Alert>
                                            )}
                                            {mode == "E" && values.Status == "QR" && (
                                                <Alert variant="filled" sx={{ mt: 1 }} severity="warning">
                                                    Your Over Time request status Query.
                                                </Alert>
                                            )} */}

                                            {/* {Number(values.NumberOfHours) > 10 && (
                                                <Alert variant="filled" sx={{ mt: 1 }} severity="warning">
                                                    No. of Hours must be less than or equal to 10.
                                                </Alert>
                                            )} */}
                                        </React.Fragment> : false}
                                    </FormControl>


                                </Box>
                                <Box
                                    display="flex"
                                    justifyContent="end"
                                    mt="20px"
                                    gap="20px"
                                    padding={1}
                                    flexDirection={isNonMobile ? "row" : "column"}
                                >
                                    {data.Status == "AP" && (
                                        <Alert variant="filled" sx={{ mt: 1 }} severity="success">
                                            Your Overtime request has been Approved.
                                        </Alert>
                                    )}

                                    {data.Status == "RJ" && (
                                        <Alert variant="filled" sx={{ mt: 1 }} severity="error">
                                            Your Overtime request has been Rejected.
                                        </Alert>
                                    )}
                                    {data.Status == "QR" && (
                                        <Alert variant="filled" sx={{ mt: 1 }} severity="warning">
                                            Your Overtime request has been Queried.
                                        </Alert>
                                    )}
                                    <TextField
                                        required
                                        name="password"
                                        type="password"
                                        id="password"
                                        label="Password"
                                        variant="standard"
                                        focused
                                        value={values.password}
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        fullWidth={isNonMobile ? false : true}
                                        sx={{ gridColumn: "span 2", width: 300 }}
                                        inputProps={{ readOnly: data.Status == "AP" || data.Status == "RJ" ? true : false }}
                                    />
                                    <LoadingButton
                                        disabled={data.Status == "AP" || data.Status == "RJ"}
                                        color="success"
                                        variant="contained"
                                        type="submit"
                                        loading={isLoading}
                                    >
                                        Submit
                                    </LoadingButton>
                                </Box>
                            </form>

                        )}
                    </Formik>

                    {/* </Box> */}
                </Paper>

            ) : (
                false
            )}

        </React.Fragment>
    );
};

export default Otapproval;
